import { ROOT_SECTION } from 'shared-base';
import { images } from './ImageSelector.data';
import { Image, Wrapper } from './ImageSelector.style';

const ROOT = ROOT_SECTION('image-to-3d');

export type ImageSelectorProps = {
  onSelect: (url: string) => void;
};

export function ImageSelector(props: ImageSelectorProps) {
  function renderImage(image: string) {
    const url = `${ROOT}/${image}`;

    const style: React.CSSProperties = {
      backgroundImage: `url(${url})`,
    };

    return (
      <Image key={image} className='image' style={style} onMouseDown={() => props.onSelect(url)} />
    );
  }

  function renderImages() {
    return images.map((image: string) => renderImage(image));
  }

  return (
    <Wrapper className='ImageSelector-wrapper' data-testid='ImageSelector-wrapper'>
      {renderImages()}
    </Wrapper>
  );
}

export default ImageSelector;
